import React, { useEffect, Suspense, lazy } from "react";
// ? Redux
import Connect from "../../../shared/redux/Connect.hoc";
import { ToastContainer } from 'react-toastify'

// ! Routes
import { Route, Switch } from "react-router-dom";

// * Components
import Perfil from '../../../containers/private/Perfil/Perfil.container'
import Mensajeria from '../../../containers/private/Mensajeria/Mensajeria.container'

import CreateMensajeria from '../../../components/public/Mensajeria/Create.Mensajeria'
import ToolBar from '../../../shared/components/ToolBar/ToolBar';
import Home from '../../../components/public/Home/Home'


import FooterBar from '../../../shared/components/Footer/FooterBar'
import CreateServicio from "../../../components/public/Servicios/Create.servicio";
import ServicioContainer from "../../../containers/private/Servicio/Servicio.container";
import Welcome from "../../../components/private/Welcome/Welcome.component";
function RoutesPrivate({ setFondo}) {
  useEffect(() => { }, []);
  return (
    <div >
      <header>
        <ToolBar />
      </header>
      <Switch>
        <Route path='/' component={Home} exact />
        <Route path='/welcome' component={Welcome} exact />
        <Route path='/perfil' component={Perfil} exact />
        <Route path='/newmensajeria' component={CreateMensajeria} exact />
        <Route path='/newservice' component= {CreateServicio} exact />
        <Route path='/mismensajerias' component={Mensajeria} exact />
        <Route path='/misservicios' component={ServicioContainer} exact />

      </Switch>
     

    
      <ToastContainer />
    </div>

  )
}
export default Connect(RoutesPrivate);
